import { z } from "zod"
import { Asset, AssetList } from "../../model/asset/asset"

const assetSchema = z.object({
    id: z.string(),
    name: z.string(),
    status: z.string(),
    type: z.string(),
    license_plate: z.string().nullish(),
    license_plate_country_code: z.string().nullish(),
})

export const assetListSchema = z.object({
    items: z.array(assetSchema),
    _links: z.object({
        next: z.object({
            href: z.string().nullish(),
        }).nullish()
    }).nullish(),

})

export type AssetListRest = z.infer<typeof assetListSchema>

export const toAssetsList = (src: AssetListRest): AssetList =>
    ({
        items: src.items.map((item): Asset => ({
            id: item.id,
            name: item.name,
            licensePlate: item.license_plate ?? undefined,
            licensePlateCountryCode: item.license_plate_country_code ?? undefined,
            status: item.status,
            type: item.type
        })),
        nextPageUrl: src._links?.next?.href || undefined
    })